module.exports = __webpack_public_path__ + "img/SC.f0b83ffc.svg";